module.exports = __webpack_public_path__ + "img/giovanni_.e5367573.jpg";